import React from 'react';

export const NotificationIndicator: React.FC<{
  counter: number;
  bgColor: string;
}> = ({ counter, bgColor }) => (
  <div
    style={{
      width: '20px',
      height: '20px',
      padding: '0 6px',
      backgroundColor: bgColor,
      borderRadius: '50%',
      color: 'white',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      fontSize: '10px'
    }}>
    {counter > 99 ? '99+' : counter}
  </div>
);
